import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { StarIcon, TrendingUpIcon } from 'lucide-react';
export function ProofSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const testimonials = [{
    quote: 'I uploaded my first video in 7 days and made $120 in my first week! The system actually works.',
    author: 'Michael R.',
    role: 'Former 9-5 Employee',
    result: '$120 first week'
  }, {
    quote: "Finally, a system that works without filming myself every day. I've built 3 channels in 2 months.",
    author: 'Sarah K.',
    role: 'Digital Entrepreneur',
    result: '3 channels launched'
  }, {
    quote: 'As an introvert, this was exactly what I needed. No camera, no stress, just results.',
    author: 'David L.',
    role: 'Software Developer',
    result: '$2,400/month'
  }];
  return <section ref={ref} className="relative w-full py-24 md:py-32 px-4 bg-bg-primary" data-id="element-238">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(0,255,136,0.05)_0%,_transparent_50%)] pointer-events-none" data-id="element-239" />

      <div className="relative max-w-6xl mx-auto" data-id="element-240">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-241">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-242">
            Real People.{' '}
            <span className="text-accent-green" data-id="element-243">Real Results.</span>
          </h2>
          <p className="text-text-muted text-lg max-w-2xl mx-auto" data-id="element-244">
            Shift from content consumer to digital asset owner in just 7 days.
          </p>
        </motion.div>

        {/* Stats Bar */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="glass-card rounded-2xl p-6 md:p-8 mb-12" data-id="element-245">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-246">
            <div data-id="element-247">
              <div className="text-3xl md:text-4xl font-black text-accent-green" data-id="element-248">
                500+
              </div>
              <div className="text-text-muted text-sm" data-id="element-249">Students Enrolled</div>
            </div>
            <div data-id="element-250">
              <div className="text-3xl md:text-4xl font-black text-accent-cyan" data-id="element-251">
                7
              </div>
              <div className="text-text-muted text-sm" data-id="element-252">Days to First Video</div>
            </div>
            <div data-id="element-253">
              <div className="text-3xl md:text-4xl font-black text-accent-green" data-id="element-254">
                $30K
              </div>
              <div className="text-text-muted text-sm" data-id="element-255">Top Monthly Earner</div>
            </div>
            <div data-id="element-256">
              <div className="text-3xl md:text-4xl font-black text-accent-cyan" data-id="element-257">
                0%
              </div>
              <div className="text-text-muted text-sm" data-id="element-258">Face Required</div>
            </div>
          </div>
        </motion.div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-6" data-id="element-259">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.3 + index * 0.1
        }} className="glass-card rounded-2xl p-6" data-id="element-260">
              {/* Stars */}
              <div className="flex gap-1 mb-4" data-id="element-261">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-yellow-500 fill-yellow-500" data-id="element-262" />)}
              </div>

              {/* Quote */}
              <p className="text-text-light mb-6 leading-relaxed" data-id="element-263">
                "{testimonial.quote}"
              </p>

              {/* Author */}
              <div className="flex items-center justify-between" data-id="element-264">
                <div data-id="element-265">
                  <div className="font-semibold text-white" data-id="element-266">
                    {testimonial.author}
                  </div>
                  <div className="text-text-muted text-sm" data-id="element-267">
                    {testimonial.role}
                  </div>
                </div>
                <div className="flex items-center gap-1 text-accent-green text-sm font-semibold" data-id="element-268">
                  <TrendingUpIcon className="w-4 h-4" data-id="element-269" />
                  {testimonial.result}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}